<template>
    <div class="combined-view">
      <StockTicker />
      <UserGreeting />
      <FinancialCalendar />


  

      <button @click="openCatExplanation('Financial Diary')"><i class="fa fa-paw risk-icon"></i> Info</button>
    <FinancialDiary />
   <button @click="openCatExplanation('SubscriptionTracker')"><i class="fa fa-paw risk-icon"></i> Info</button>
   <SubscriptionTracker />
   <button @click="openCatExplanation('Employer Benefits')"><i class="fa fa-paw risk-icon"></i> Info</button>
   <EmployerBenefits />

   <button @click="openCatExplanation('Watchlist')"><i class="fa fa-paw risk-icon"></i> Info</button>
      <UserWatchList />

  
      

    </div>
  </template>
  
<script>
import UserGreeting from './UserGreeting.vue';

import FinancialCalendar from './FinancialCalendar.vue';

import StockTicker from './StockTicker.vue';

import EmployerBenefits from '@/components/EmployerBenefits.vue';

import UserWatchList from '@/components/UserWatchlist.vue';

import FinancialDiary from '@/components/FinancialDiary.vue';
import SubscriptionTracker from '@/components/SubscriptionTracker.vue';


import { ref } from 'vue';
import Swal from 'sweetalert2';




  export default {
    components: {
    FinancialCalendar,
    UserGreeting,
    StockTicker,
    EmployerBenefits,
    UserWatchList,
    FinancialDiary,
    SubscriptionTracker,


},
  
setup() {
  
    // Define an array of cat explanations
    const catExplanations = ref([
      {
        section: 'networth',
        title: 'Cat Speak - Total Net Worth',
        text: 'Think of total net worth as your financial score in the big game of life. It is the sum of everything you own of value, like your house, savings, artwork, jewelry and any investments. From this total subtract what you owe like loans, mortgages or credit card debts. It is like a cat with a stash of treats - the more treats you have and the fewer you owe, the happier and more secure you are. A healthy net worth means you are on your way to being cozy with less stress. '
      },
      {
        section: 'financialassets',
        title: 'Cat Speak  - Financial Assets',
        text: 'Financial Assets are your cash, stocks, bonds, and retirement savings. They are like your quick-access treats and long-term nibbles. Liquidity is key - it is how fast you can turn these assets into cash. Think of it as how quickly you can get to your food bowl when you are hungry!'
      },
      {
        section: 'personalassets',
        title: 'Cat Speak  - Personal Assets',
        text: 'Personal Assets are like your cozy cat bed, favorite scratching post, and shiny collars. They include your house, car, art, and jewelry. These are more illiquid, meaning they are like that snug hiding spot or high perch – valuable but not quick to turn into cash. They are your long-term comfort, not your everyday treats!'
      },
      {
        section: 'liabilities',
        title: 'Cat Speak  - Liabilities',
        text: 'Total Liabilities are like the amount of cat food you have promised to share with your furry friends. It is the total you owe, like loans and credit card debts. Just like keeping track of treats you need to give back, it is important to manage these to stay purr-fectly balanced financially or else face some serious consequences!'
      },
      {
        section: 'Financial Diary',
        title: 'Cat Speak  - Financial Diary',
        text: 'Your Financial Diary is like a cozy corner for thoughtful purring about your relationship with money. It\'s filled with prompts that nudge you to ponder why you pounce on certain financial decisions and what makes you curl up around others. This diary isn\'t just about tracking your daily financial tail-chasing; it\'s a journey of self-discovery, helping you understand the \'why\' behind your money moves. Reflect, write, and discover.  Every entry brings you closer to mastering the art of financial feline grace!'
      },
      {
        section: 'budgetManagement',
        title: 'Cat Speak  - Budget Management',
        text: 'Think of Budget Management as your personal goal tracker in the financial jungle. It\'s where you set your treasure hunting targets (amount budgeted), track the gems you\'ve already gathered (amount saved), and see how much more adventure awaits (amount remaining). But there\'s a twist – the \'expected\' column! It\'s like your feline instinct, telling you if you\'re likely to catch that bird (meet your goal) based on your current prowling pattern. This isn\'t just about keeping tabs on your treats; it\'s about strategically planning your leaps and bounds to achieve your financial dreams.'
      },
      {
        section: 'SubscriptionTracker',
        title: 'Cat Speak  - Subscription Tracker',
        text: 'Keep tabs on your subscriptions like a cat watching a laser dot. Subscription Tracker helps you keep track of all those recurring nibbles that can creep up and eat a big chunk of your cheese. Stay on top of them, so they don\'t pounce on your wallet unexpectedly! It\'s almost important to keep track of what subscriptions you use often and not.  Companies are relying on you signing up and forgetting all about them even when you run out of things to watch on Netflix'
      },
      {
        section: 'Employer Benefits',
        title: 'Cat Speak  - Employer Benefits',
        text: 'Employer Benefits are like those extra-special treats added to your bowl, making up an important part of your total compensation package. In times when the cost of living keeps climbing, it\'s wise to make full use of these benefits. Think of them like a visit to the vet for a dental check-up or a relaxing massage session.  They\'re not just perks, they\'re essential for your well-being. Regular dentist visits keep your fangs sharp and your purrfect smile shining, while massages can be just the thing to help you unwind and stretch out those kitty muscles. So, don\'t just nap in the sun; make sure you\'re using all the sunny spots your employer offers, especially during the longer nights!'
      },
      {
        section: 'Financial Holdings',
        title: 'Cat Speak - Investment Holdings',
        text: 'Your investment holdings are your treasure trove of investments: stocks, ETFs, currencies...maybe even some gold coins. They\'re the assets you\'ve gathered and are nurturing, watching them grow like a well-tended catnip garden.'
      },
      {
        section: 'Watchlist',
        title: 'Cat Speak  - User Watchlist',
        text: 'Your Watchlist is like a list of birds you’re curious about outside the window. It includes all the stocks, indices, ETFs, crypto, and currencies you’re keeping an eye on. It’s important to watch them closely – you never know when you might want to make a leap!'
      },
      {
        section: 'Trade Journal',
        title: 'Cat Speak  - Trade Journal',
        text: 'Take the emotions out of trading and track when you did well and when you did not.  Even cats misses jumps sometimes and it is important to learn from our fails.'
      },
      {
        section: 'Stock Screener',
        title: 'Cat Speak  Stock Screener',
        text: 'A Stock Screener is like a high-tech bird-watching tool. It helps you filter and find stocks that meet your specific criteria. It’s like having a special radar to spot the best birds (stocks) in a big, busy forest (market).'
      },
      {
        section: 'Dividends',
        title: 'Cat Speak  - Dividend Tracker',
        text: 'Warm N. Fluffy loves these treats. Dividends are the little rewards you get for owning parts of a company – like getting extra treats just for being a loyal and patient cat. They’re a way your investments can pay off, providing a steady stream of little financial purrs. '
      },
   
    
  
    ]);

    // Method to open a specific cat explanation
    const openCatExplanation = (sectionKey) => {
      const explanation = catExplanations.value.find(ex => ex.section === sectionKey);
      if (explanation) {
        Swal.fire({
          title: explanation.title,
          text: explanation.text,
          confirmButtonText: 'Understood',
       
          // Additional customization options here
        });
      }
    };

    // Return the reactive properties and methods
    return {
      openCatExplanation
    };
  }
};
  </script>
  

  <style scoped>
  button {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}
  </style>
  